import { type IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import NavLink from 'src/components/navigation/NavLink';
import { Tooltip, TooltipContent, TooltipTrigger, TooltipPortal } from 'src/registry/ui/Tooltip';
import { cn } from 'src/utils';

type NavigationSidebarButtonProps = {
    icon: IconProp;
    className?: string;
    link: string;
    tooltip: string;
    isCustomActive?: boolean;
};

const NavigationSidebarButton = ({ icon, link, className, tooltip, isCustomActive }: NavigationSidebarButtonProps) => {
    return (
        <Tooltip>
            <TooltipTrigger asChild>
                <NavLink
                    to={link}
                    routerClassName={({ isActive }) => {
                        const isActiveCustom = isActive || (isCustomActive ?? false);
                        return cn(
                            'flex h-10 w-10 xs:h-12 xs:w-12 shrink-0 items-center justify-center rounded-md transition-colors hover:bg-primary-600 dark:hover:bg-primary-950',
                            isActiveCustom && 'bg-primary-600 dark:bg-primary-950 text-white',
                            className,
                        );
                    }}
                >
                    <FontAwesomeIcon icon={icon} />
                </NavLink>
            </TooltipTrigger>
            <TooltipPortal>
                <TooltipContent className="hidden sm:block" side="right">
                    <p>{tooltip}</p>
                </TooltipContent>
            </TooltipPortal>
        </Tooltip>
    );
};

export default NavigationSidebarButton;
